import { AlertTriangle } from "lucide-react";
import * as React from "react";
import { cn } from "../lib/utils";
import { Button } from "./button";

interface CompactErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  message: string;
  onRetry?: () => void;
}

function CompactError({ title, message, onRetry, className, ...props }: CompactErrorProps) {
  return (
    <div
      className={cn("flex flex-col items-center justify-center gap-2 p-4", className)}
      {...props}
    >
      <AlertTriangle className="h-6 w-6 text-destructive" />
      {title && <p className="text-xs font-medium text-foreground">{title}</p>}
      <p className="text-xs text-muted-foreground text-center line-clamp-2">{message}</p>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} className="mt-1">
          Retry
        </Button>
      )}
    </div>
  );
}

export { CompactError };
export type { CompactErrorProps };
